import { createContext, useContext } from 'react';

const emptyMailingListContextValue = {
    mailingListID: null,
    mailingListEmails: [],
    mailingListEmailSet: new Set(),
    onAddItem: () => {},
    onAddAllContacts: () => {},
    addingAllContacts: false,
};

export const MailingListContext = createContext(emptyMailingListContextValue);

export function useMailingListContext() {
    return useContext(MailingListContext);
}
